import React, { useCallback, useEffect, useState } from 'react';
import { Guide } from 'gatorcomponents';
import * as Styles from './Popover.styles';

const Popover = ({
  steps, guideRef, storageKey, top, left,
}) => {
  const [refElement, setRefElement] = useState({
    top: 0,
    left: 0,
    width: 0,
    height: 0,
  });
  const [guideWithCoordinates, setGuideWithCoordinates] = useState({});

  const maskPadding = 4;
  const popoverMargin = 8;

  const updateGuidePositionByButtonRef = useCallback(() => {
    if (guideRef && guideRef.current) {
      const {
        width, height,
      } = guideRef.current.getBoundingClientRect();

      setRefElement({
        top: guideRef.current.offsetTop, left: guideRef.current.offsetLeft, width, height,
      });
    }
  }, [guideRef, setRefElement]);

  const executeGuideCoordinates = useCallback(() => {
    updateGuidePositionByButtonRef();

    window.addEventListener('resize', updateGuidePositionByButtonRef);

    return () => {
      window.removeEventListener('resize', updateGuidePositionByButtonRef);
    };
  }, [updateGuidePositionByButtonRef]);

  const updateCoordinates = useCallback(() => {
    const stepsWithCoordinates = steps.map(step => ({
      ...step,
      popover: {
        ...step.popover,
        $top: top || refElement.top + refElement.height + (maskPadding * 2) + popoverMargin,
        $left: left || refElement.left - (refElement.width + maskPadding),
      },
      mask: {
        ...step.mask,
        $width: refElement.width + (maskPadding * 2),
        $height: refElement.height + (maskPadding * 2),
        $top: refElement.top - maskPadding,
        $left: refElement.left - maskPadding,
        $customRadius: step.mask && step.mask.customRadius,
      },
    }));

    setGuideWithCoordinates(stepsWithCoordinates);
  }, [refElement, steps, top, left]);

  useEffect(() => {
    executeGuideCoordinates();
  }, [executeGuideCoordinates]);

  useEffect(() => {
    updateCoordinates();
  }, [updateCoordinates]);

  const setStorageKey = () => {
    if (storageKey) {
      localStorage.setItem(storageKey, true);
    }
  };

  const isOnDefaultPosition = () => {
    if (refElement.top === 0 && refElement.left === 0) {
      return true;
    }
    return false;
  };

  const canShowPopover = !isOnDefaultPosition();

  return (
    canShowPopover && (
      <Styles.GuideContainer>
        <Guide steps={guideWithCoordinates} onClick={setStorageKey} />
      </Styles.GuideContainer>
    )
  );
};

export default Popover;
